export enum HomebaseUrl {
  Production = 'https://homebase.affecttherapeutics.com',
  Staging = 'https://homebase.staging.affecttherapeutics.com'
}
